import { render, staticRenderFns } from "./OneKidsConfig.vue?vue&type=template&id=7dca228c&scoped=true"
import script from "./OneKidsConfig.vue?vue&type=script&lang=js"
export * from "./OneKidsConfig.vue?vue&type=script&lang=js"
import style0 from "./OneKidsConfig.vue?vue&type=style&index=0&id=7dca228c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dca228c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dca228c')) {
      api.createRecord('7dca228c', component.options)
    } else {
      api.reload('7dca228c', component.options)
    }
    module.hot.accept("./OneKidsConfig.vue?vue&type=template&id=7dca228c&scoped=true", function () {
      api.rerender('7dca228c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/OneKidsConfig.vue"
export default component.exports